import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import '../../css/mail/NewMail.css';

const NewMail = () => {

    useEffect(() => {
        document.title = "Login - Construction and Engineering";  // Set the page title
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", "Login to your Construction and Engineering Saudi Arabia account.");
        }

        // Add the 'login-body' class to the body
        document.body.classList.add('dashboard-body');

        // Cleanup: Remove the 'login-body' class when the component unmounts
        return () => {
            document.body.classList.remove('dashboard-body');
        };
    }, []);

    const [checkboxes, setCheckboxes] = useState({
        checkbox1: false,
        checkbox2: false,
    });

    const [selectedRadio, setSelectedRadio] = useState(null); // Tracks the selected radio button

    const handleCheckboxChange = (name) => {
        setCheckboxes((prev) => ({
            ...prev,
            [name]: !prev[name],
        }));
    };

    const handleRadioChange = (value) => {
        setSelectedRadio(value);
    };

    const [labelText, setLabelText] = useState("Default Label Text");

    const handleButtonClick = (text) => {
        setLabelText(text);
    };

    return (
        <div className='new-mail'>
            <Navbar />
            <div className="title">
                <label>New Mail</label>
            </div>
        </div>
    );
};

export default NewMail;
